import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { AnalyticsContext, H1, P, Spinner } from 'shared';
import { useGetConsumerApplicationsV2ApproveChargeFlowsTokenQuery, } from 'consumer-applications-v2-api';
import accountLookupErrorIcon from 'images/utility-icons/account-lookup-error.svg';
import { setApproveChargeFlowData } from '../../actions';
import { selectors } from '../../reducer';
import SupportSection from '../components/SupportSection';
import { createStatusRouter } from '../utils';
function ApproveChargeFlowWrapper() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const { path } = useRouteMatch();
    const { analytics } = useContext(AnalyticsContext);
    const handleStatusRouting = createStatusRouter(history, dispatch, analytics, path);
    // Get token from query parameter
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    // Get approve charge flow data from Redux
    const approveChargeFlowData = useSelector(selectors.approveChargeFlowData);
    // API call to get approve charge flow data
    const { data: apiData, isLoading, error, } = useGetConsumerApplicationsV2ApproveChargeFlowsTokenQuery({ token: token || '' }, { skip: !token || !!approveChargeFlowData } // Skip if no token or data already exists in Redux
    );
    useEffect(() => {
        // If we have API data and no data in Redux, store it
        if (apiData && !approveChargeFlowData) {
            dispatch(setApproveChargeFlowData(apiData));
        }
    }, [apiData, approveChargeFlowData, dispatch]);
    useEffect(() => {
        const flowData = approveChargeFlowData || apiData;
        if (flowData && 'status' in flowData && flowData.status) {
            handleStatusRouting(flowData);
        }
    }, [approveChargeFlowData, apiData, handleStatusRouting]);
    // Show loading state
    if (isLoading && !approveChargeFlowData) {
        return (_jsxs("div", { className: "approve-charge-landing", children: [_jsx("div", { className: "approve-charge-landing__icon-placeholder", children: _jsx("div", { className: "flex justify-center", children: _jsx(Spinner, {}) }) }), _jsx(P, { className: "mar-t-20 text-center", children: "Loading your application..." })] }));
    }
    // Show error state if no token or error
    if (!token || (error && !approveChargeFlowData)) {
        return (_jsxs("div", { className: "approve-charge-landing", children: [_jsx("div", { className: "approve-charge-landing__icon-placeholder", children: _jsx("img", { src: accountLookupErrorIcon, alt: "Error loading application" }) }), _jsx(H1, { className: "mar-b-20", variant: "headline-large", children: "Error Loading Application" }), _jsx(P, { className: "mar-b-40", children: "We're sorry, but we were unable to load your approve and charge link." }), _jsx(SupportSection, {})] }));
    }
    // Show loading while determining route
    return (_jsxs("div", { className: "approve-charge-landing", children: [_jsx("div", { className: "approve-charge-landing__icon-placeholder", children: _jsx("div", { className: "flex justify-center", children: _jsx(Spinner, {}) }) }), _jsx(P, { className: "mar-t-20 text-center", children: "Processing your application..." })] }));
}
export default ApproveChargeFlowWrapper;
